import $ from 'jquery';

$(document).on("click", "span.delete" , function()
{
    // remove parent bg-image and uploadFile
    $(this).parent().css({
        "background-image":"none",
        "display":"none"
    }).children('uploadFile').remove();

});

$(function() {
    $(document).on("change",".uploadFile", function()
    {
        let uploadFile = $(this);
        let files = !!this.files ? this.files : [];
        if (!files.length || !window.FileReader) return; // no file selected, or no FileReader support

        if (/^image/.test( files[0].type)){ // only image file
            console.log('file selected');
            var reader = new FileReader(); // instance of the FileReader
            reader.readAsDataURL(files[0]); // read the local file

            reader.onloadend = function(){ // set image data as background of div
                uploadFile.closest(".upload-container").find('.image-preview').css({
                    "background-image":"url("+this.result+")",
                    "display":"flex"
                });
            }
        }
    });
});
